export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_09.84d965cc.jpg";